import NavMenuItem from "../ui/nav-menu-item";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import SideBarContext from "../../contexts/side-bar-context";
import { useContext } from "react";
import { useTranslations } from "next-intl";
import { isPegInstalled } from "../../lib/auth";

const BottomMenuItems = () => {
  const userCtx = useContext(UserContext);
  const {activeBusiness, isGuestUser} = useContext(BusinessContext);
  const business = activeBusiness;
  const user = userCtx.user;
  const t = useTranslations('nav');

  return (
    <div className="grid gap-[4px] mb-[20px]">
      {(user.is_pseudonymous === false && business.is_pseudonymous === false && !isGuestUser) &&
        <NavMenuItem icon='settings' href='/manage-people'>{t('settings')}</NavMenuItem>
      }
      <NavMenuItem normalizeRoute newTab icon='bug' href="https://forms.gle/rqLWcSkrpiNouynD8">{t('reportABug')}</NavMenuItem>
      <NavMenuItem normalizeRoute newTab icon='life-buoy' href="https://docs.google.com/forms/d/e/1FAIpQLScIaAP1FSbZuFGwPsxp4ojs8IkK0IT29JsAdOtrKAlpiaMQhg/viewform">{t('help&support')}</NavMenuItem>
    </div>
  );
};

export default BottomMenuItems;
